import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function FloatingWhatsApp() {
  const { settings } = useSettings();
  const num = settings.contact_whatsapp || "908503093581";
  const phoneDisplay = settings.contact_phone || "0850 309 35 81";
  const msg = encodeURIComponent(
    "Merhaba, Midye Merkezi sitenizden ulaşıyorum. Sipariş hakkında bilgi almak istiyorum."
  );
  return (
    <a
      href={`https://wa.me/${num}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="WhatsApp ile sipariş ver"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-emerald-500 text-white shadow-2xl hover:bg-emerald-600 hover:scale-105 transition-all duration-300 px-4 py-3 group"
      style={{ boxShadow: "0 12px 28px rgba(16, 185, 129, 0.45)" }}
    >
      <span className="relative flex h-5 w-5 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-emerald-300 opacity-75 animate-ping" />
        <MessageCircle size={20} className="relative z-10" />
      </span>
      <span className="hidden sm:inline font-semibold text-sm whitespace-nowrap">
        {phoneDisplay}
      </span>
    </a>
  );
}
